import bulletpoints from "bulletpoints";

export const SHAPES = new bulletpoints().shapes;
export const CHARTS = new bulletpoints().charts;
